import bbc from 'static/img/home/pressSlider/bbc.svg';
import dailyTelegraph from 'static/img/home/pressSlider/dailyTelegraph.svg';
import eveningStandard from 'static/img/home/pressSlider/eveningStandard.svg';
import guardian from 'static/img/home/pressSlider/guardian.svg';
import itv from 'static/img/home/pressSlider/itv.svg';
import metro from 'static/img/home/pressSlider/metro.svg';
import techCrunch from 'static/img/home/pressSlider/techCrunch.svg';
import tes from 'static/img/home/pressSlider/tes.svg';

interface IPressSlider {
  img: string;
  label: string;
}

export interface IGoogleReview {
  img: string;
  name: string;
  rating: number;
  time: string;
  positive: string;
  description: string;
  link: string;
}

export interface ITrustpilotList {
  img: string;
  name: string;
  rating: number;
  time: string;
  subtitle: string;
  description: string;
  link: string;
}

export const pressSlider: IPressSlider[] = [
  {
    label: 'theguardian',
    img: guardian
  },
  {
    label: 'bbc',
    img: bbc
  },
  {
    label: 'dailyTelegraph',
    img: dailyTelegraph
  },
  {
    label: 'metro',
    img: metro
  },
  {
    label: 'eveningStandard',
    img: eveningStandard
  },
  {
    label: 'itv',
    img: itv
  },
  {
    label: 'techCrunch',
    img: techCrunch
  },
  {
    label: 'tes',
    img: tes
  }
];

export const GoogleReviewCarouselConfig = {
  dots: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  speed: 500,
  arrows: true,
  responsive: [
    {
      breakpoint: 1460,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1
      }
    }
  ]
};

export const carouselConfigs = {
  dots: false,
  slidesToShow: 6,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1560,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1260,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 915,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 776,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }
  ]
};

export const GoogleReviews: IGoogleReview[] = [
  {
    img: 'A',
    name: 'Arushee T',
    rating: 5,
    time: '4 month ago',
    positive: 'Communication, Professionalism, Quality, Value',
    description: 'Tutor House has provided exceptional support and motivation throughout my year of retaking. Right from the start , Alex Dyer ,the Director and all the tutors were incredibly encouraging of the career path I wanted to take .They were with...',
    link: 'https://www.google.com/maps/contrib/111967625050619438088/reviews/@51.5188962,-0.173369,17z/data=!3m1!4b1!4m3!8m2!3m1!1e1'
  },
  {
    img: 'R',
    name: 'Rafael Garcia-Navarro',
    rating: 5,
    time: '8 month ago',
    positive: 'Communication, Professionalism, Quality, Value',
    description: 'Tutor House not only provided for our daughter a way forward at a difficult time, but a transformational experience. Over two years two fine tutors home-schooled our daughter in English Literature and Politics, which enabled her to complete...',
    link: 'https://www.google.com/maps/contrib/105758403859624649685/reviews?_ga=2.263313676.1059451040.1606316419-907029034.1606316419'
  },
  {
    img: 'M',
    name: 'Mark S',
    rating: 5,
    time: '4 month ago',
    positive: 'Communication, Professionalism, Quality, Value',
    description: 'Tutor House provided excellent teachers who helped my daughter achieve top A-Level results.  She is now on her way to Oxford...',
    link: 'https://www.google.com/maps/contrib/108853748148354641767/reviews/@51.4979475,-0.0825931,12z/data=!3m1!4b1!4m3!8m2!3m1!1e1'
  },
  {
    img: 'J',
    name: 'Juliette Corrin',
    rating: 5,
    time: '3 years ago',
    positive: 'Communication, Professionalism, Quality, Value',
    description: `Tutorhouse has turned my sons retakes into an experience he's so glad not to have missed.  His highly qualified tutors have been inspiring, enthusiastic, expert in their field, knowledgeable about exam board requirements and enormously generous...`,
    link: 'https://www.google.com/maps/contrib/104409903950599448449/reviews/@49.6143005,6.2149671,6z/data=!3m1!4b1!4m3!8m2!3m1!1e1'
  },
  {
    img: 'H',
    name: 'Hamssadvani Srirangeraj',
    rating: 5,
    time: '1 year ago',
    positive: 'Communication, Professionalism, Quality, Value',
    description: `The tutors at tutor house are well versed and passionate about their subjects. I used to hate chemistry but now I’m considering it at as my University degree. I got a D in chemistry last year but I've improved so much I’m able to aim for an A or A^*.`,
    link: 'https://www.google.com/maps/contrib/116082102219057979380/reviews?_ga=2.98588318.1059451040.1606316419-907029034.1606316419'
  }
];

export const TrustpilotList: ITrustpilotList[] = [
  {
    img: 'Y',
    name: 'Yvonne K',
    rating: 5,
    time: '4 month ago',
    subtitle: 'Experience as a parent of a child tutored/assisted by Tutor House',
    description: `Tutor House has worked with my daughter over the past three years now; supporting her with one-to-one tuition for her A-Level French as well as assisting her throughout her UCAS process. Their friendly team has been extremely helpful (often responding...`,
    link: 'https://uk.trustpilot.com/users/5ee770c47fb435652fa81e40',
  },
  {
    img: 'E',
    name: 'Edward',
    rating: 5,
    time: '5 month ago',
    subtitle: 'We needed a tutor to help our son get an A in English Literature A Level',
    description: 'We needed a tutor to help our son get at least an A in his English Literature A level to get what he needed for University. Tutor House were extremely helpful and helped with choice of exam board, and enrollment in a suitable exam centre for an independent...',
    link: 'https://uk.trustpilot.com/users/4edb9c2c00006400010f8057'
  },
  {
    img: 'L',
    name: 'Lauren Lindsey',
    rating: 5,
    time: '4 month ago',
    subtitle: 'Exactly what you want from a tutor…',
    description: 'Exactly what you want from a tutor service, reliable, friendly and quality education.',
    link: 'https://uk.trustpilot.com/users/5895b09f0000ff000a73c4b1'
  },
  {
    img: 'D',
    name: 'Dee',
    rating: 5,
    time: '4 month ago',
    subtitle: 'Excellent',
    description: 'Have been using Tutor House for my daughter whom is a year 6 student and found the service to be excellent. She has really enjoyed the English and Maths work set out for her to complete online with her tutor and has come away more confident each time. As a...',
    link: 'https://uk.trustpilot.com/users/5ed181ccafcf38493152e2bb'
  },
  {
    img: 'J',
    name: 'Jamie Wickham-Eade',
    rating: 5,
    time: '4 month ago',
    subtitle: 'Absolutely amazing tutor finding…',
    description: 'Absolutely amazing tutor finding service. Would highly recommend to anyone in need of quality tutors!',
    link: 'https://uk.trustpilot.com/users/5fad033cbdde17001afc8386'
  },
];
